// app/javascript/controllers/media_viewer_trigger_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    // This controller triggers the image viewer to open
    // Usage:
    // <div data-controller="media-viewer-trigger"
    //      data-action="click->media-viewer-trigger#open"
    //      data-media-viewer-trigger-target-param="viewer-id"
    //      data-media-viewer-trigger-index-param="0"
    //      data-media-viewer-trigger-media-id-param="uuid">

  open(event) {
      // Don't open viewer if clicking on a button/form/link that is NOT the trigger itself
      // (e.g. Delete button inside a grid cell).
      const target = event.target
      const control = target.closest('button') || target.closest('form') || target.closest('a')
      if (control && control !== event.currentTarget) {
          return
      }

      const targetViewerId = event.params.target
      const index = event.params.index || 0
      const mediaId = event.params.mediaId // Album mode: stable ID-based navigation

      // Find the viewer element
      const viewerElement = document.getElementById(targetViewerId)

      if (viewerElement) {
          // Dispatch custom event to open the viewer
          viewerElement.dispatchEvent(new CustomEvent("open-image-viewer", {
              detail: {index: parseInt(index, 10), mediaId: mediaId}
          }))
      } else {
          console.warn(`Viewer element with ID "${targetViewerId}" not found`)
      }
  }

  stopPropagation(event) {
      event.stopPropagation()
  }
}
